export enum CONNEXION_STEPS {
  LOGIN_EMAIL,
  LOGIN_PASSWORD,
  REGISTER_NAME,
  REGISTER_PASSWORD,
  RESET_PASSWORD,
  VALIDATE_EMAIL,
}

export enum AuthStrategy {
  EMAIL_PASSWORD = "email_password",
  SSO_SAML = "sso_saml",
}

export enum AuthFlowEnum {
  LEGACY = "legacy",
  OIDC = "oidc",
}

export enum AuthModeEnum {
  LEGACY = "legacy",
  OIDC = "oidc",
  IMPERSONATION = "impersonation",
}

export enum OidcPhaseEnum {
  IDLE = "idle",
  INTERACTION = "interaction",
  COMPLETING = "completing",
  ERROR = "error",
}

/** Why a rejected OIDC password attempt restarted the login, shown under the fresh password field. */
export enum OidcLoginNoticeEnum {
  PASSWORD_REJECTED = "password_rejected",
  TICKET_EXPIRED = "ticket_expired",
}

/**
 * Value of the `?error=` flag the login page reads to explain why a redirect landed there.
 */
export enum LoginErrorEnum {
  SSO = "sso",
  LOGOUT_LOCAL = "logout_local",
}

/**
 * Outcome of a role re-synchronisation (see `revalidateRoles` in the auth store).
 * Distinguishing SESSION_LOST matters: carrying on with a reset store leaves the
 * user on protected content with no roles, and showing the "Vos droits ont été modifiés"
 * page over a dead session traps them on a screen whose only exit logs them out.
 */
export enum RoleSyncResultEnum {
  /** Roles are unchanged (or the check was throttled) — nothing to do. */
  UNCHANGED = "unchanged",
  /**
   * Only roles ranked below the user's highest one were gained (see `isLowerRoleGain`) — a group admin
   * made referent of the session they just created, say — and the JWT was re-minted. Nothing to
   * acknowledge.
   */
  LOWER_ROLES_GAINED = "lower_roles_gained",
  /** Roles changed server-side and the JWT was re-minted — have the user acknowledge it. */
  CHANGED = "changed",
  /** The session is over, or roles and JWT could not be re-synced — log out. */
  SESSION_LOST = "session_lost",
}
export enum EmbeddedAuthResultEnum {
  SIGNED_OUT = "signed_out",
  LOCAL_ONLY = "local_only",
}
